import { render, staticRenderFns } from "./CardTransactionsTable.vue?vue&type=template&id=7e091eb2&scoped=true"
import script from "./CardTransactionsTable.vue?vue&type=script&lang=js"
export * from "./CardTransactionsTable.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=7e091eb2&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e091eb2",
  null
  
)

export default component.exports